// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-04917d00] {\n  color: #E9A021;\n  cursor: default;\n}\n.home-container .pictures-display[data-v-04917d00] {\n  width: 100%;\n  height: 220px;\n  overflow: hidden;\n}\n.home-container .pictures-display img[data-v-04917d00] {\n  width: 200px;\n  height: 200px;\n  margin-top: 10px;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
